module.exports = __webpack_public_path__ + "img/arrow-up-red.068da64e.svg";